module.exports = __webpack_public_path__ + "static/media/ponds.53fd2dcd.png";